<template>
  <div class="country-code">
    <div class="modal country-code-modal">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <p class="title">
            {{ $t("language.select-country-code") }}
          </p>
          <table class="table is-fullwidth is-hoverable">
            <tbody>
              <tr @click="countryCode('+66')">
                <td class="flag2">
                  <!-- <country-flag country="th" rounded="true" size="big" /> -->
                  <flag iso="th" :squared="false" />
                </td>
                <th>+66</th>
                <td class="name">Thailand</td>
              </tr>
              <tr @click="countryCode('+81')" :rounded="true">
                <td class="flag2">
                  <!-- <country-flag country="jp" /> -->
                  <flag iso="jp" :squared="false" />
                </td>
                <th>+81</th>
                <td class="name">Japan</td>
              </tr>
              <tr @click="countryCode('+86')">
                <td class="flag2">
                  <flag iso="cn" :squared="false" />
                </td>
                <th>+86</th>
                <td class="name">China</td>
              </tr>
              <tr @click="countryCode('+65')">
                <td class="flag2">
                  <flag iso="sg" :squared="false" />
                </td>
                <th>+65</th>
                <td class="name">Singapore</td>
              </tr>
              <tr @click="countryCode('+95')">
                <td class="flag2">
                  <flag iso="mm" :squared="false" />
                </td>
                <th>+95</th>
                <td class="name">Myanmar</td>
              </tr>
              <tr @click="countryCode('+1')">
                <td class="flag2">
                  <flag iso="us" :squared="false" />
                </td>
                <th>+1</th>
                <td class="name">United States</td>
              </tr>
              <tr @click="countryCode('+44')">
                <td class="flag2">
                  <flag iso="gb" :squared="false" />
                </td>
                <th>+44</th>
                <td class="name">United Kingdom</td>
              </tr>
              <tr>
                <td class="flag2">
                  <i class="fa fa-question unknown-flag" />
                </td>
                <th>
                  <span style="position: relative; top: 3px">+</span>
                  <input
                    class="input"
                    v-model="other"
                    type="number"
                    maxlength="4"
                  />
                </th>
                <td class="name" @click="otherCountryCode">
                  {{ $t("other") }}&nbsp;
                  <a v-if="other" class="button is-primary is-small is-rounded">
                    <i class="fa fa-chevron-right fa-lg" />
                  </a>
                  <p v-if="error && !other" class="has-text-danger error">
                    {{ error }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountryCodeModal",
  data() {
    return {
      other: "",
      error: null,
    };
  },
  mounted() {},
  methods: {
    closeModal() {
      this.other = "";
      this.error = null;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    countryCode(e) {
      this.console("countryCode", e);
      this.$emit("countryCode", e);
      setTimeout(() => this.closeModal(), 500);
    },
    otherCountryCode() {
      if (this.other.length === 0) {
        this.error = "Enter a country code";
        return;
      }
      if (this.other.length > 4) {
        this.error = "Invalid country code";
        this.other = "";
        return;
      }
      this.error = null;
      this.console("other countryCode", this.other);
      this.$emit("countryCode", `+${this.other}`);
      setTimeout(() => this.closeModal(), 500);
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  /* border-radius: 25px; */
  padding: 10px;
  max-width: 640px;
}
.title {
  font-size: 1.3em;
  font-weight: 500;
  color: #555;
  margin-bottom: 12px !important;
  margin-top: 6px;
}
.table {
  /* background-color: #eef; */
  background-color: rgb(245, 245, 245);
  border-radius: 3px;
  font-size: 1.2em;
}
.table td,
.table th {
  vertical-align: middle;
  border-bottom: 1px solid white;
}
.table th {
  width: 75px;
  padding-right: 0;
}
.flag2 {
  /* filter: drop-shadow(1px 1px 3px #777); */
  text-align: right;
}
.flag-icon {
  filter: drop-shadow(1px 1px 3px #777);
  font-size: 1.6em;
  border-radius: 6px;
}
.name {
  text-align: left;
  padding-left: 10px;
}
.unknown-flag {
  filter: drop-shadow(1px 1px 3px #777);
  /* padding: 9px 18px; */
  padding: 5.5px 13px;
  background-color: white;
  border-radius: 6px;
}
.input {
  width: 45px;
  margin-left: 0px;
  display: inline-block;
  font-weight: bold;
}
tr:active {
  transform: scaleY(0.95);
}
.error {
  /* height: 0; */
  /* margin-top: -6px; */
  font-size: 0.8em;
  line-height: 0.8em;
}
</style>